// @flow
import * as React from 'react';
import type { intlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import Head from 'next/head';
import { Link } from '../../../router';
import GlobalCss from '../../../common/GlobalCss';
import Button from '../../../common/forms/Button';
import messages from '../../messages';
import Logo from '../../../common/Logo';
import styles from './styles';

type Props = {
  intl: intlShape,
  verticalName: string,
};

function Error500({ intl, verticalName }: Props): React.Node {
  return (
    <div>
      <Head>
        <title>{intl.formatMessage(messages.errorHasOccurred)}</title>
        <meta name="robots" content="noindex,nofollow,noarchive" />
        <meta name="googlebot" content="noindex,nofollow,noarchive" />
        <GlobalCss />
      </Head>
      <div className="main">
        <Link route="home">
          <a>
            <Logo type={verticalName} width={75} />
          </a>
        </Link>
        <div className="content">
          <img width="120" height="120" src="/static/img/homes/icon_error.png" />
          <h1>
            <FormattedMessage {...messages.errorHasOccurred} />
          </h1>
          <Link route="home">
            <a>
              <Button
                type="button"
                title={<FormattedMessage {...messages.goToHomepage} />}
                color="blue"
                fullWidth
              />
            </a>
          </Link>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

export default Error500;



// WEBPACK FOOTER //
// ./app/Error/components/Error500/index.js